import { useState } from 'react';
import { createSubscribeHandoffUrl } from '../api/subscribeHandoff';

interface AddSeatsCTAProps {
  /** Optional label override. Defaults to "Add seats". */
  label?: string;
  /** Visual style variant. 'primary' is the full button; 'inline' is an underlined link for inline use. */
  variant?: 'primary' | 'inline';
}

export function AddSeatsCTA({ label = 'Add seats', variant = 'primary' }: AddSeatsCTAProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Mint a handoff token so the subscribe app can bootstrap a session —
  // without it the user lands on the subscribe app's "unauthorized" page.
  const handleClick = async () => {
    setError(null);
    setLoading(true);
    try {
      const url = await createSubscribeHandoffUrl();
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  const classes =
    variant === 'primary'
      ? 'flex items-center gap-2 px-4 py-2 bg-hbs-primary hover:bg-hbs-primary-hover text-white rounded-hbs-md text-sm font-medium transition-colors disabled:opacity-60'
      : 'text-sm text-hbs-primary hover:text-hbs-primary underline disabled:opacity-60';

  return (
    <div className="inline-flex flex-col items-start gap-1">
      <button id="add-seats-button" type="button" onClick={handleClick} disabled={loading} className={classes}>
        {loading ? 'Opening…' : label}
      </button>
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
